/* eslint-disable react-hooks/exhaustive-deps */
import { Pagination, Table, Tag } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../../assets/Images/icons/icon-back';
import RiskRegisterService from '../../../services/RiskRegister.service';

export default function History() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    let { riskId } = useParams();
    const [historyInfo, setHistoryInfo] = useState([]);

    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });

    useEffect(() => {
        getHistoryDetail();
    }, [riskId]);

    const getHistoryDetail = async (pageValue) => {
        try {
            const { data } = await RiskRegisterService.getHistoryDetail({
                riskRegisterHistoryId: riskId,
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
            });
            setLoading(false);
            setHistoryInfo(data?.resultData || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        if (loading) {
            getHistoryDetail(currentPage);
        }
    }, [currentPage.page, currentPage.pageSize]);

    const _getTagStatus = (e) => {
        switch (e.statusTh) {
            case 'แบบร่าง':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center"
                        style={{ color: '#65707A', borderColor: '#65707A' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            case 'รอตรวจสอบ':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center"
                        style={{ color: '#F9C153', borderColor: '#F9C153' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            case 'ตรวจสอบแล้ว':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            case 'ส่งคืนแก้ไข':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center"
                        style={{ color: '#F0536F', borderColor: '#F0536F' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            default:
                return '-';
        }
    };

    const columns = [
        {
            title: <div>{t('Title')}</div>,
            dataIndex: 'title',
            key: 'title',
            width: '34%',
        },
        {
            title: <div>{t('OldData')}</div>,
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: '33%',
            render: (_, { oldValue }) => (
                <>
                    {oldValue.length > 0 ? (
                        oldValue.map((item) => {
                            return <div className="text-gray-600">{item}</div>;
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                </>
            ),
        },
        {
            title: <div>{t('CurrentData')}</div>,
            dataIndex: 'newValue',
            key: 'newValue',
            width: '33%',
            render: (_, { newValue }) => (
                <>
                    {newValue.length > 0 ? (
                        newValue.map((item) => {
                            return <div className="text-gray-600">{item}</div>;
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                </>
            ),
        },
    ];

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        // navigate(`/risk-assessment/${riskId}/view`);
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </div>
                {t('History')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('RiskRegister')} /
                </span>
                <span className="text-sm text-gray-400">
                    {t('Risk RiskRegister List')} /
                </span>
                <span className="text-sm text-gray-400">
                    {t('RiskRegisterDetail')} /
                </span>
                <span> {t('History')} </span>
            </div>
            <div className="bg-white rounded-xl p-4 my-4">
                <div className="grid grid-cols-2 p-4">
                    <div className="col-span-1">
                        <div className="grid grid-cols-6 pb-2">
                            <div className="col-span-1 font-semibold">
                                {t('LogDate')} :
                            </div>
                            <div className="col-span-5">
                                {historyInfo?.logDate
                                    ? moment(historyInfo.logDate).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-6 pb-2">
                            <div className="col-span-1 font-semibold">
                                {t('Update By')} :
                            </div>
                            <div className="col-span-5">
                                {historyInfo?.updateBy || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-6">
                            <div className="col-span-1 font-semibold">
                                {t('Action')} :
                            </div>
                            <div className="col-span-5">
                                <Tag
                                    className="rounded-xl -my-1 text-center px-4 text-white"
                                    color="#7B67FB"
                                >
                                    {i18n.language === 'en'
                                        ? historyInfo?.actionEn
                                        : historyInfo?.actionTh}
                                </Tag>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="grid grid-cols-6 pb-2">
                            <div className="col-span-1 font-semibold">
                                {t('Version')} :
                            </div>
                            <div className="col-span-5">
                                {historyInfo?.version || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-6">
                            <div className="col-span-1 font-semibold">
                                {t('Status')} :
                            </div>
                            <div className="col-span-5">
                                {_getTagStatus(historyInfo)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl p-4">
                <Table
                    bordered
                    className="inbox_table"
                    dataSource={historyInfo?.details}
                    columns={columns}
                    pagination={false}
                />
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={currentPage?.pageSize}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div>
        </div>
    );
}
